// ! poikalon majmuasi
import poi1 from "../../photos/uzb_bux_poi1.webp";
import poi2 from "../../photos/uzb_bux_poi2.webp";
import poi3 from "../../photos/uzb_bux_poi3.webp";


// ! arka majmuasi
import ark1 from "../../photos/uzb_bux_ark1.webp";
import ark2 from "../../photos/uzb_bux_ark2.webp";
import ark3 from "../../photos/uzb_bux_ark3.webp";

// ! lyabi hovuz
import lyabi1 from "../../photos/uzb_bux_lyabi1.webp";
import lyabi2 from "../../photos/uzb_bux_lyabi2.webp";
import lyabi3 from "../../photos/uzb_bux_lyabi3.webp";



// ! somoniylar maqbarasi
import somoniy1 from "../../photos/uzb_bux_somoni1.webp";
import somoniy2 from "../../photos/uzb_bux_somoni2.webp";
import somoniy3 from "../../photos/uzb_bux_somoni3.webp";

// ! chor muzeyi
import chor1 from "../../photos/uzb_bux_chor1.webp";
import chor2 from "../../photos/uzb_bux_chor2.webp";
import chor3 from "../../photos/uzb_bux_chor3.webp";
const bukhara = {
    uz: {
        key: "bukhara",
        title: "Buxoro — ming yillik ilm va ma’naviyat markazi",

        intro: `
Buxoro — O‘zbekistonning eng qadimiy va muqaddas shaharlaridan biri bo‘lib, 2500 yildan ortiq tarixga ega.
Bu shahar qadimda Buyuk Ipak Yo‘lining eng muhim savdo va ilm markazlaridan biri bo‘lgan.
    `,

        history: `
Buxoro — 2500 yildan ortiq tarixga ega bo‘lgan Markaziy Osiyoning eng muhim diniy, ilmiy va savdo markazlaridan biridir.

Qadimda u Buyuk Ipak Yo‘lining asosiy to‘xtash nuqtalaridan biri bo‘lib, Sharq va G‘arb o‘rtasidagi madaniy almashinuv markazi bo‘lgan.

IX–X asrlarda Buxoro Somoniylar davrida Islom sivilizatsiyasining eng yirik ilm markaziga aylangan. Bu davrda Imom al-Buxoriy, Ibn Sino kabi buyuk allomalar yashab ijod qilgan.

Buxoro “Qubbat ul-Islom” — ya’ni Islomning gumbazi deb atalgan, chunki bu yerda yuzlab madrasa va ilm markazlari bo‘lgan.

Keyinchalik shahar Qoraxoniylar, Xorazmshohlar, Temuriylar va Buxoro amirligi davrida rivojlanishda davom etgan.

Buxoroda minglab tarixiy yodgorliklar saqlanib qolgan bo‘lib, ularning aksariyati hali ham o‘zining asl holatini yo‘qotmagan.
`,

        sections: [

            {
                title: "Poi-Kalyan majmuasi — Buxoro",

                content: `
Poi-Kalyan majmuasi — Buxoro shahrining eng muqaddas va eng mashhur tarixiy markazlaridan biridir.

U “Buyuk minora majmuasi” sifatida ham tanilgan bo‘lib, Islom me’morchiligining eng go‘zal namunalaridan biri hisoblanadi.

Majmua Buxoroning diniy, ilmiy va tarixiy yuragi bo‘lib kelgan.
    `,

                details: `
Poi-Kalyan majmuasi XII asrdan boshlab shakllangan va keyingi asrlarda kengaytirilgan.

📌 Majmua tarkibi:
- Kalyan minorasi (1127-yil)
- Kalyan masjidi
- Mir Arab madrasasi

📌 Tarix:
Kalyan minorasi qoraxoniylar davrida Arslonxon tomonidan qurdirilgan. U nafaqat masjid minorasi, balki karvonlar uchun yo‘l ko‘rsatuvchi mayoq vazifasini ham bajargan.

📌 Arxitektura:
- Pishiq g‘ishtdan qurilgan
- Moviy va oq koshin bezaklar
- Islomiy geometrik naqshlar
- Ulkan peshtoqlar va simmetrik tuzilma

📌 Ahamiyati:
Poi-Kalyan Buxoroning “islomiy ramzi” hisoblanadi va asrlar davomida ilm-fan va diniy markaz bo‘lib kelgan.
    `,

                facts: [
                    "Buxoro shahrida joylashgan",
                    "XII asrdan boshlab shakllangan",
                    "Kalyan minorasi 1127-yilda qurilgan",
                    "Arslonxon tomonidan qurdirilgan",
                    "Majmua 3 asosiy qismdan iborat",
                    "Mir Arab madrasasi mashhur ta’lim markazi",
                    "Kalyan masjidi katta jome masjid",
                    "Islom me’morchiligining durdonasi",
                    "Buyuk Ipak Yo‘li davrida muhim markaz",
                    "Minora karvonlar uchun mayoq bo‘lgan",
                    "Pishiq g‘ishtdan qurilgan",
                    "Moviy koshinlar bilan bezatilgan",
                    "Buxoroning diniy markazi",
                    "UNESCO meros obidalari tarkibida",
                    "Sharq me’morchiligining eng muhim namunasi",
                    "Turizm uchun eng mashhur joylardan biri",
                    "Asrlar davomida saqlanib qolgan",
                    "Simmetrik arxitektura uslubi",
                    "Buxoroning eng taniqli ramzi",
                    "Kechasi yoritilganda juda chiroyli ko‘rinadi"
                ],
                images: [poi1, poi2, poi3,]
            },

            {
                title: "Ark qal’asi — Buxoro",

                content: `
Ark qal’asi — Buxoro shahrining eng qadimiy va eng muhim tarixiy qal’alaridan biridir.

U asrlar davomida Buxoro amirlarining rasmiy qarorgohi bo‘lib xizmat qilgan va shahar hokimiyatining markazi hisoblangan.

Bugungi kunda Ark qal’asi Buxoroning eng mashhur sayyohlik va tarixiy obidalaridan biri hisoblanadi.
    `,

                details: `
Ark qal’asi Buxoroning eng qadimiy inshootlaridan biri bo‘lib, uning dastlabki shakllanishi miloddan avvalgi davrlarga borib taqaladi. Hozirgi ko‘rinishi esa asosan XVI–XIX asrlarda shakllangan.

📌 Tarixiy ahamiyati:
- Buxoro amirlarining qarorgohi bo‘lgan
- Davlat boshqaruvi markazi bo‘lgan
- Harbiy va siyosiy qarorlar shu yerda qabul qilingan

📌 Tuzilishi:
- Mustahkam qal’a devorlari
- Amir saroyi
- Qabul zallari
- Masjid
- Qamoqxona (zindan)
- Zarbxona (tanga zarb qilish joyi)
- Harbiy xonalar

📌 Arxitektura:
- Qalin loy g‘isht devorlar
- Mustahkam mudofaa tizimi
- Ichki hovlilar tizimi
- Sharqona an’anaviy qurilish uslubi

📌 Qiziqarli jihat:
Ark qal’asi baland tepalik ustiga qurilgan bo‘lib, u Buxoro shahrining eng yaxshi himoyalangan nuqtasi bo‘lgan.
    `,

                facts: [
                    "Buxoro shahrida joylashgan",
                    "Eng qadimiy qal’alardan biri",
                    "Dastlabki tarixi ming yillarga borib taqaladi",
                    "XVI–XIX asrlarda amirlar qarorgohi bo‘lgan",
                    "Davlat boshqaruv markazi bo‘lgan",
                    "Harbiy strategiya markazi bo‘lgan",
                    "Zindan (qamoqxona) mavjud bo‘lgan",
                    "Zarbxona faoliyat yuritgan",
                    "Balans tepalik ustiga qurilgan",
                    "Mustahkam mudofaa devorlariga ega",
                    "Loy g‘ishtdan qurilgan",
                    "Buxoroning eng yirik qal’asi",
                    "Turizm uchun mashhur joy",
                    "Ichki saroy majmuasiga ega",
                    "Islomiy-sharqona me’morchilik namunasi",
                    "UNESCO meros obidalari tarkibida",
                    "Ko‘p marta qayta tiklangan",
                    "Amirlik davrining siyosiy markazi",
                    "Buxoro tarixining yuragi hisoblanadi",
                    "Bugungi kunda muzey sifatida ochiq"
                ],
                images: [ark1, ark2, ark3,]
            },

            {
                title: "Lyabi-Hauz majmuasi — Buxoro",

                content: `
Lyabi-Hauz — Buxoro shahrining eng mashhur va eng go‘zal tarixiy maydonlaridan biridir.

U katta hovuz atrofida joylashgan me’moriy majmua bo‘lib, asrlar davomida Buxoro hayotining markazi hisoblangan.

Bugungi kunda Lyabi-Hauz sayyohlar dam oladigan, tarix va madaniyat uyg‘unlashgan eng mashhur maskanlardan biridir.
    `,

                details: `
Lyabi-Hauz majmuasi XVI–XVII asrlarda shakllangan bo‘lib, Buxoro shahrining markaziy ijtimoiy va savdo hududi bo‘lgan.

📌 Majmua tarkibi:
- Nodir Devonbegi madrasasi
- Nodir Devonbegi xonaqohi
- Ko‘hna hovuz (hauz)
- Ko‘plab savdo va hunarmandchilik do‘konlari

📌 Tarix:
Hovuz qadimda ichimlik suvi manbai va shahar hayotining markazi bo‘lgan. Karvonlar, savdogarlar va mahalliy aholi shu yerda to‘plangan.

📌 Arxitektura:
- Moviy koshinli madrasa
- Katta markaziy suv havzasi
- Chinor daraxtlari bilan o‘ralgan maydon
- Sharqona simmetrik dizayn

📌 Ahamiyati:
Lyabi-Hauz Buxoroning “ijtimoiy yuragi” bo‘lib, bu yerda ilm, savdo va madaniyat birlashgan.
    `,

                facts: [
                    "Buxoro shahrining markazida joylashgan",
                    "XVI–XVII asrlarda shakllangan",
                    "Markaziy suv havzasi mavjud",
                    "Nodir Devonbegi tomonidan qurdirilgan",
                    "Madrasa va xonaqoh majmuasi bor",
                    "Savdo markazi bo‘lgan",
                    "Karvonlar to‘xtash joyi bo‘lgan",
                    "Chinor daraxtlari bilan mashhur",
                    "Buxoroning ijtimoiy markazi",
                    "Sharqona me’morchilik namunasi",
                    "Turizm uchun eng mashhur joy",
                    "Hozirgi kunda dam olish maskani",
                    "Hovuz suv saqlash uchun ishlatilgan",
                    "UNESCO merosi bilan bog‘liq hudud",
                    "Kechasi juda chiroyli yoritiladi",
                    "Ko‘plab restoran va choyxonalar bor",
                    "Buxoroning eng jonli hududi",
                    "Madaniyat va savdo markazi bo‘lgan",
                    "Sayyohlar eng ko‘p boradigan joylardan biri",
                    "Tarix va zamonaviy hayot uyg‘unlashgan maskan"
                ],
                images: [lyabi1, lyabi2, lyabi3,]
            },

            {
                title: "Somoniylar maqbarasi — Buxoro",

                content: `
Somoniylar maqbarasi — Buxoro shahrining eng qadimiy va eng muhim me’moriy yodgorliklaridan biridir.

U Somoniylar davlati hukmdorlari sulolasi uchun qurilgan bo‘lib, islom me’morchiligining eng ilk va eng mukammal namunalaridan biri hisoblanadi.

Bugungi kunda bu maqbara O‘zbekiston tarixidagi eng qadimiy saqlanib qolgan obidalardan biri sifatida qadrlanadi.
    `,

                details: `
Somoniylar maqbarasi IX–X asrlar (taxminan 892–943-yillar) oralig‘ida qurilgan bo‘lib, Ismoil Somoniy nomi bilan bog‘lanadi.

📌 Tarixiy ahamiyati:
- Somoniylar sulolasining maqbarasi
- Islomiy me’morchilikning eng qadimiy namunasi
- Markaziy Osiyoda g‘isht bezak san’atining boshlanishi

📌 Arxitektura:
- Kvadrat shakldagi bino
- Pishiq g‘ishtdan qurilgan
- G‘ishtlar orqali geometrik naqshlar hosil qilingan
- To‘liq simmetrik dizayn
- Yorug‘lik va soya o‘yiniga asoslangan bezaklar

📌 Ahamiyati:
Somoniylar maqbarasi islom dunyosida “g‘isht me’morchiligi durdonasi” sifatida tanilgan va keyingi asrlardagi ko‘plab me’moriy uslublarga asos bo‘lgan.
    `,

                facts: [
                    "Buxoro shahrida joylashgan",
                    "IX–X asrlarda qurilgan",
                    "Ismoil Somoniy nomi bilan bog‘liq",
                    "Somoniylar sulolasi maqbarasi",
                    "Islom me’morchiligining eng qadimiy namunasi",
                    "Pishiq g‘ishtdan qurilgan",
                    "Kvadrat shaklga ega",
                    "Simmetrik dizayn bilan qurilgan",
                    "Geometrik g‘isht naqshlari bor",
                    "Dunyodagi eng qadimiy saqlangan islom obidalaridan biri",
                    "Buxoroning tarixiy markazida joylashgan",
                    "UNESCO merosi tarkibida",
                    "G‘isht san’atining eng yuqori namunasi",
                    "Yorug‘lik va soya effektiga asoslangan",
                    "Keyingi me’morchilikka katta ta’sir qilgan",
                    "Sharq me’morchiligining boshlanish nuqtasi",
                    "Ziyoratgoh sifatida mashhur",
                    "Tarixiy va diniy ahamiyati juda yuqori",
                    "Dunyo me’morchiligi durdonasi",
                    "Buxoroning eng qadimiy obidasi"
                ],

                images: [somoniy1, somoniy2, somoniy3,]
            },

            {
                title: "Chor Minor — Buxoro",

                content: `
Chor Minor — Buxoro shahrining eng noyob va o‘ziga xos me’moriy obidalaridan biridir.

U to‘rtta kichik minora bilan bezatilgan kirish darvozasi bo‘lib, o‘zining g‘ayrioddiy dizayni bilan darhol e’tiborni tortadi.

Chor Minor Buxoroning eng fotogenik va sayyohlar eng ko‘p tashrif buyuradigan joylaridan biridir.
    `,

                details: `
Chor Minor XIX asr boshlarida, taxminan 1807-yilda Xalifa Niyozqul tomonidan qurdirilgan.

📌 Ma’nosi:
“Chor Minor” so‘zi forscha bo‘lib, “To‘rt minora” degan ma’noni anglatadi.

📌 Tuzilishi:
- 4 ta kichik minora
- Markaziy gumbazli bino
- Kirish darvozasi (portal)
- Ichki hovli

📌 Arxitektura:
- Moviy va yashil koshinlar
- Har bir minoraning o‘ziga xos bezagi bor
- Sharqona simmetriya va g‘ayrioddiy dizayn
- Hind va Markaziy Osiyo uslublari uyg‘unligi

📌 Ahamiyati:
Chor Minor aslida madrasa kirish qismi bo‘lgan, lekin uning asosiy binosi vaqt o‘tishi bilan yo‘qolib ketgan.
    `,

                facts: [
                    "Buxoro shahrida joylashgan",
                    "Taxminan 1807-yilda qurilgan",
                    "Xalifa Niyozqul tomonidan qurdirilgan",
                    "‘Chor Minor’ — to‘rt minora degani",
                    "Aslida madrasa kirish qismi bo‘lgan",
                    "4 ta noyob minora bilan mashhur",
                    "Moviy koshinlar bilan bezatilgan",
                    "Noyob simmetrik dizaynga ega",
                    "Hind va Sharq uslubi aralashgan",
                    "Buxoroning eng fotogenik joyi",
                    "Kichik, lekin juda mashhur obida",
                    "UNESCO hududi yaqinida joylashgan",
                    "Turistik maskan sifatida mashhur",
                    "Asosiy madrasa yo‘qolib ketgan",
                    "Kirish darvozasi sifatida qurilgan",
                    "Sharq me’morchiligining noodatiy namunasi",
                    "Buxorodagi eng o‘ziga xos inshootlardan biri",
                    "Sayyohlar eng ko‘p suratga oladigan joy",
                    "Kechasi juda chiroyli ko‘rinadi",
                    "Buxoroning ramziy obidalaridan biri"
                ],
                images: [chor1, chor2, chor3,]
            }

        ]
    },

    ru: {
        key: "bukhara",

        title: "Бухара — тысячелетний центр науки и духовности",

        intro: `
Бухара — один из древнейших и самых священных городов Узбекистана, история которого насчитывает более 2500 лет.

С древних времён этот город был одним из важнейших торговых, культурных и научных центров Великого Шёлкового пути.
    `,

        history: `
Бухара — один из важнейших религиозных, научных и торговых центров Центральной Азии с более чем 2500-летней историей.

В древности город являлся одной из главных остановок Великого Шёлкового пути, где встречались культуры Востока и Запада, развивались торговля, наука и ремёсла.

В IX–X веках, в эпоху государства Саманидов, Бухара стала одним из крупнейших центров исламской цивилизации. Именно в этот период здесь жили и творили выдающиеся учёные, такие как Имам аль-Бухари и Ибн Сина (Авиценна).

Бухару называли «Куббат аль-Ислам» («Купол Ислама»), поскольку в городе располагались сотни медресе, библиотек и научных центров, сделавших его одним из крупнейших образовательных центров мусульманского мира.

Позднее город продолжал процветать во времена Караханидов, Хорезмшахов, Тимуридов и Бухарского эмирата.

До наших дней в Бухаре сохранились тысячи исторических памятников, многие из которых дошли практически в своём первоначальном виде. Благодаря этому город считается одним из самых хорошо сохранившихся исторических центров Центральной Азии и включён в список Всемирного наследия ЮНЕСКО.
`,

        sections: [
            {
                title: "Комплекс Пои-Калян — Бухара",

                content: `
Комплекс Пои-Калян — один из самых священных и известных исторических ансамблей города Бухары.

Он также известен как «Комплекс Великого минарета» и считается одним из величайших шедевров исламской архитектуры.

На протяжении многих веков этот комплекс являлся религиозным, научным и историческим сердцем Бухары.
    `,

                details: `
Комплекс Пои-Калян начал формироваться в XII веке и постепенно расширялся в последующие столетия.

📌 В состав комплекса входят:
- Минарет Калян (1127 год)
- Мечеть Калян
- Медресе Мир-и Араб

📌 История:
Минарет Калян был построен по приказу караханидского правителя Арслан-хана. Он служил не только минаретом главной мечети, но и ориентиром для караванов, проходивших по Великому Шёлковому пути.

📌 Архитектура:
- Построен из обожжённого кирпича
- Украшен голубыми и белыми керамическими изразцами
- Богат исламскими геометрическими орнаментами
- Монументальные порталы и идеально симметричная композиция

📌 Значение:
Комплекс Пои-Калян считается главным исламским символом Бухары. На протяжении веков он был важнейшим центром религии, образования и науки.
    `,

                facts: [
                    "Расположен в городе Бухара",
                    "Формировался начиная с XII века",
                    "Минарет Калян построен в 1127 году",
                    "Возведён по приказу Арслан-хана",
                    "Комплекс состоит из трёх основных сооружений",
                    "Медресе Мир-и Араб — один из самых известных исламских учебных центров",
                    "Мечеть Калян является главной соборной мечетью города",
                    "Выдающийся памятник исламской архитектуры",
                    "Был важным центром эпохи Великого Шёлкового пути",
                    "Минарет служил ориентиром для караванов",
                    "Построен из обожжённого кирпича",
                    "Украшен голубыми керамическими изразцами",
                    "Является главным религиозным центром Бухары",
                    "Входит в список объектов Всемирного наследия ЮНЕСКО",
                    "Один из лучших образцов восточной архитектуры",
                    "Одно из самых популярных туристических мест Бухары",
                    "Сохранился на протяжении многих веков",
                    "Отличается гармоничной симметричной архитектурой",
                    "Считается главным символом Бухары",
                    "Особенно впечатляюще выглядит в вечерней подсветке"
                ],

                images: [poi1, poi2, poi3,]
            },
            {
                title: "Крепость Арк — Бухара",

                content: `
Крепость Арк — одна из самых древних и значимых исторических крепостей Бухары.

На протяжении многих веков она служила официальной резиденцией бухарских эмиров и являлась главным административным центром города.

Сегодня крепость Арк считается одной из самых известных исторических достопримечательностей и туристических символов Бухары.
    `,

                details: `
Крепость Арк является одним из древнейших сооружений Бухары. Её происхождение уходит в глубокую древность, а современный облик в основном сформировался в XVI–XIX веках.

📌 Историческое значение:
- Официальная резиденция бухарских эмиров
- Центр государственного управления
- Здесь принимались важнейшие военные и политические решения

📌 Структура крепости:
- Массивные крепостные стены
- Дворец эмира
- Залы для официальных приёмов
- Мечеть
- Тюрьма (Зиндан)
- Монетный двор
- Военные помещения

📌 Архитектура:
- Толстые стены из сырцового и обожжённого кирпича
- Надёжная оборонительная система
- Внутренние дворы
- Традиционный архитектурный стиль Востока

📌 Интересный факт:
Крепость Арк построена на высоком искусственном холме, благодаря чему она являлась наиболее защищённой частью Бухары.
    `,

                facts: [
                    "Расположена в городе Бухара",
                    "Одна из древнейших крепостей Центральной Азии",
                    "Её история насчитывает несколько тысячелетий",
                    "В XVI–XIX веках служила резиденцией бухарских эмиров",
                    "Была центром государственного управления",
                    "Являлась главным военно-стратегическим центром",
                    "На территории находилась тюрьма (Зиндан)",
                    "Здесь действовал монетный двор",
                    "Построена на высоком искусственном холме",
                    "Имеет мощные оборонительные стены",
                    "Возведена из глиняного и обожжённого кирпича",
                    "Самая известная крепость Бухары",
                    "Популярная туристическая достопримечательность",
                    "Включает дворцовый комплекс",
                    "Выдающийся памятник исламской и восточной архитектуры",
                    "Входит в список объектов Всемирного наследия ЮНЕСКО",
                    "Неоднократно реставрировалась",
                    "Была политическим центром Бухарского эмирата",
                    "Считается историческим сердцем Бухары",
                    "Сегодня открыта для посетителей как музей"
                ],

                images: [ark1, ark2, ark3,]
            },

            {
                title: "Комплекс Ляби-Хауз — Бухара",

                content: `
Комплекс Ляби-Хауз — одна из самых известных и красивых исторических площадей Бухары.

Это архитектурный ансамбль, расположенный вокруг большого пруда, который на протяжении многих веков являлся центром городской жизни.

Сегодня Ляби-Хауз — одно из самых популярных мест Бухары, где история, культура и атмосфера Востока гармонично сочетаются, привлекая тысячи туристов.
    `,

                details: `
Комплекс Ляби-Хауз сформировался в XVI–XVII веках и был главным общественным и торговым центром Бухары.

📌 В состав комплекса входят:
- Медресе Надир Диван-Беги
- Ханака Надир Диван-Беги
- Исторический пруд (хауз)
- Многочисленные торговые и ремесленные лавки

📌 История:
В прошлом пруд служил главным источником питьевой воды и являлся сердцем городской жизни. Здесь собирались караваны, купцы и жители города.

📌 Архитектура:
- Медресе, украшенное голубыми керамическими изразцами
- Большой центральный водоём
- Площадь, окружённая вековыми платанами
- Традиционная симметричная архитектура Востока

📌 Значение:
Ляби-Хауз считается «социальным сердцем» Бухары, где на протяжении веков пересекались наука, торговля и культура.
    `,

                facts: [
                    "Расположен в центре города Бухара",
                    "Сформировался в XVI–XVII веках",
                    "Включает большой исторический пруд",
                    "Построен по инициативе Надир Диван-Беги",
                    "В состав входят медресе и ханака",
                    "Был важным торговым центром",
                    "Служил местом остановки караванов",
                    "Известен своими многовековыми платанами",
                    "Являлся общественным центром Бухары",
                    "Выдающийся памятник восточной архитектуры",
                    "Одно из самых популярных туристических мест",
                    "Сегодня является зоной отдыха и прогулок",
                    "Пруд использовался для хранения питьевой воды",
                    "Расположен в исторической зоне Всемирного наследия ЮНЕСКО",
                    "Особенно красиво выглядит в вечерней подсветке",
                    "Рядом расположено множество ресторанов и чайхан",
                    "Самый оживлённый район исторической Бухары",
                    "На протяжении веков был центром торговли и культуры",
                    "Одно из самых посещаемых мест туристами",
                    "Гармонично сочетает историческое наследие и современную жизнь"
                ],

                images: [lyabi1, lyabi2, lyabi3,]
            },
            {
                title: "Мавзолей Саманидов — Бухара",

                content: `
Мавзолей Саманидов — один из самых древних и выдающихся архитектурных памятников Бухары.

Он был построен как усыпальница правителей династии Саманидов и считается одним из самых ранних и совершенных образцов исламской архитектуры.

Сегодня мавзолей является одним из старейших сохранившихся памятников истории Узбекистана и представляет огромную культурную и историческую ценность.
    `,

                details: `
Мавзолей Саманидов был построен в IX–X веках (примерно между 892 и 943 годами) и тесно связан с именем Исмаила Самани.

📌 Историческое значение:
- Усыпальница династии Саманидов
- Один из древнейших памятников исламской архитектуры
- Начало развития искусства кирпичной архитектуры в Центральной Азии

📌 Архитектура:
- Квадратное здание
- Построено из обожжённого кирпича
- Геометрические узоры выполнены исключительно кирпичной кладкой
- Абсолютно симметричная композиция
- Уникальная игра света и тени создаёт декоративный эффект

📌 Значение:
Мавзолей Саманидов считается настоящим шедевром кирпичной архитектуры исламского мира и оказал большое влияние на развитие архитектурных традиций последующих эпох.
    `,

                facts: [
                    "Расположен в городе Бухара",
                    "Построен в IX–X веках",
                    "Связан с именем Исмаила Самани",
                    "Является мавзолеем династии Саманидов",
                    "Один из древнейших памятников исламской архитектуры",
                    "Построен из обожжённого кирпича",
                    "Имеет квадратную форму",
                    "Отличается идеальной симметрией",
                    "Украшен геометрическими кирпичными орнаментами",
                    "Один из древнейших сохранившихся исламских памятников мира",
                    "Находится в историческом центре Бухары",
                    "Входит в список объектов Всемирного наследия ЮНЕСКО",
                    "Является шедевром кирпичного зодчества",
                    "Архитектура основана на игре света и тени",
                    "Оказал большое влияние на развитие последующей архитектуры",
                    "Считается отправной точкой архитектуры Востока",
                    "Популярное место паломничества и туризма",
                    "Обладает высокой исторической и духовной ценностью",
                    "Признан шедевром мировой архитектуры",
                    "Один из древнейших памятников Бухары"
                ],

                images: [somoniy1, somoniy2, somoniy3,]
            },
            {
                title: "Чор-Минор — Бухара",

                content: `
Чор-Минор — один из самых необычных и уникальных архитектурных памятников Бухары.

Это входной портал, украшенный четырьмя небольшими минаретами, который сразу привлекает внимание своим необычным обликом.

Сегодня Чор-Минор считается одной из самых фотогеничных достопримечательностей Бухары и одним из самых посещаемых мест среди туристов.
    `,

                details: `
Чор-Минор был построен в начале XIX века, примерно в 1807 году, по инициативе Халифы Ниязкула.

📌 Значение названия:
Название «Чор-Минор» происходит из персидского языка и означает «Четыре минарета».

📌 Структура комплекса:
- Четыре небольших минарета
- Центральное здание с куполом
- Входной портал
- Внутренний двор

📌 Архитектурные особенности:
- Голубые и зелёные изразцы
- Каждый минарет имеет собственный декоративный стиль
- Восточная симметрия и оригинальный дизайн
- Сочетание архитектурных традиций Индии и Центральной Азии

📌 Историческое значение:
Изначально Чор-Минор являлся главным входом в медресе, однако само здание медресе со временем было утрачено.
    `,

                facts: [
                    "Расположен в городе Бухара",
                    "Построен примерно в 1807 году",
                    "Возведён по приказу Халифы Ниязкула",
                    "Название «Чор-Минор» означает «Четыре минарета»",
                    "Первоначально служил входом в медресе",
                    "Известен своими четырьмя уникальными минаретами",
                    "Украшен голубыми изразцами",
                    "Отличается необычной симметричной архитектурой",
                    "Сочетает индийские и восточные архитектурные традиции",
                    "Одна из самых фотогеничных достопримечательностей Бухары",
                    "Небольшой, но очень известный памятник",
                    "Расположен рядом с объектами Всемирного наследия ЮНЕСКО",
                    "Популярное туристическое место",
                    "Основное здание медресе не сохранилось",
                    "Был построен как входной портал",
                    "Является необычным примером восточной архитектуры",
                    "Одна из самых оригинальных построек Бухары",
                    "Одно из самых фотографируемых мест города",
                    "Особенно красив в вечерней подсветке",
                    "Является одним из символов Бухары"
                ],

                images: [chor1, chor2, chor3,]
            },
        ]
    },

    en: {
        key: "bukhara",
        title: "Bukhara — The Ancient Center of Knowledge and Spirituality",

        intro: `
Bukhara is one of the oldest and most sacred cities in Uzbekistan, with a history spanning more than 2,500 years.

For centuries, it was one of the greatest centers of trade, science, and culture along the legendary Silk Road.
    `,

        history: `
Bukhara is one of Central Asia's oldest cities, boasting a history of over 2,500 years. Throughout the centuries, it has served as a major center of religion, scholarship, commerce, and culture.

In ancient times, Bukhara was one of the principal stops along the Great Silk Road, where merchants, scholars, and travelers from East and West exchanged goods, ideas, and traditions.

During the 9th and 10th centuries, under the Samanid dynasty, Bukhara became one of the most influential centers of Islamic civilization. Great scholars such as Imam al-Bukhari and Avicenna (Ibn Sina) lived, studied, or worked during this remarkable era.

The city earned the title "Qubbat al-Islam" ("The Dome of Islam") because of its hundreds of madrasas, mosques, and institutions of higher learning.

Later, Bukhara continued to flourish under the Karakhanids, Khwarazmshahs, Timurids, and the Emirate of Bukhara, each leaving its mark on the city's rich architectural and cultural heritage.

Today, thousands of historical monuments remain preserved throughout Bukhara, making it one of the world's finest examples of a living medieval Islamic city and a UNESCO World Heritage Site.
`,

        sections: [
            {
                title: "Poi-Kalyan Complex — Bukhara",

                content: `
The Poi-Kalyan Complex is one of the most sacred and iconic historical landmarks in the city of Bukhara.

Also known as the "Great Minaret Complex," it is regarded as one of the finest masterpieces of Islamic architecture in Central Asia.

For centuries, the complex has served as the religious, educational, and historical heart of Bukhara.
    `,

                details: `
The Poi-Kalyan Complex began to take shape in the 12th century and was expanded over the following centuries.

📌 The complex includes:
- Kalyan Minaret (1127)
- Kalyan Mosque
- Mir-i-Arab Madrasa

📌 History:
The Kalyan Minaret was commissioned by the Karakhanid ruler Arslan Khan in 1127. Besides serving as the mosque's minaret, it also functioned as a landmark that guided caravans traveling along the Silk Road.

📌 Architecture:
- Constructed from baked bricks
- Decorated with elegant blue and white glazed tiles
- Intricate Islamic geometric patterns
- Monumental portals and a perfectly symmetrical layout

📌 Significance:
The Poi-Kalyan Complex is considered the spiritual symbol of Bukhara and has remained an important center of Islamic education, scholarship, and religious life for centuries.
    `,

                facts: [
                    "Located in the city of Bukhara",
                    "Construction began in the 12th century",
                    "The Kalyan Minaret was built in 1127",
                    "Commissioned by Arslan Khan",
                    "The complex consists of three main monuments",
                    "Mir-i-Arab Madrasa is one of the most prestigious Islamic schools",
                    "Kalyan Mosque is one of Central Asia's largest Friday mosques",
                    "A masterpiece of Islamic architecture",
                    "An important landmark on the Great Silk Road",
                    "The minaret once served as a beacon for caravans",
                    "Built from baked bricks",
                    "Adorned with beautiful blue glazed tiles",
                    "The religious heart of Bukhara",
                    "Part of the UNESCO World Heritage Site",
                    "One of the finest examples of Eastern architecture",
                    "One of Bukhara's most visited tourist attractions",
                    "Beautifully preserved for more than eight centuries",
                    "Features a harmonious and symmetrical architectural design",
                    "One of the most recognizable symbols of Bukhara",
                    "Especially impressive when illuminated at night"
                ],

                images: [poi1, poi2, poi3,]

            },

            {
                title: "Ark Fortress — Bukhara",

                content: `
Ark Fortress is the oldest and most important historical citadel in the city of Bukhara.

For centuries, it served as the official residence of the Emirs of Bukhara and was the political, military, and administrative center of the city.

Today, Ark Fortress stands as one of Bukhara's most famous historical landmarks and a must-visit destination for travelers exploring Uzbekistan's rich cultural heritage.
    `,

                details: `
Ark Fortress is one of the oldest structures in Bukhara, with origins dating back to ancient times. Its present appearance was largely shaped between the 16th and 19th centuries.

📌 Historical significance:
- Official residence of the Emirs of Bukhara
- Center of government and state administration
- Place where important political and military decisions were made

📌 Structure:
- Massive fortified walls
- Emir's palace
- Reception halls
- Mosque
- Prison (Zindan)
- Mint for coin production
- Military quarters

📌 Architecture:
- Thick mud-brick defensive walls
- Strong fortification system
- Spacious inner courtyards
- Traditional Central Asian and Islamic architectural style

📌 Interesting fact:
Ark Fortress was built on an elevated hill, making it the best-defended location in Bukhara and providing a strategic advantage against invading armies.
    `,

                facts: [
                    "Located in the city of Bukhara",
                    "One of the oldest fortresses in Central Asia",
                    "Its history dates back more than two thousand years",
                    "Served as the residence of the Emirs between the 16th and 19th centuries",
                    "Functioned as the administrative center of the Emirate of Bukhara",
                    "A major military and political headquarters",
                    "Included the famous Zindan prison",
                    "Contained a royal mint for coin production",
                    "Built on a raised hill for defensive purposes",
                    "Protected by massive fortified walls",
                    "Constructed primarily from mud bricks",
                    "The largest fortress in historic Bukhara",
                    "One of the city's most popular tourist attractions",
                    "Home to an impressive palace complex",
                    "A remarkable example of Islamic and Central Asian architecture",
                    "Part of the UNESCO World Heritage Site",
                    "Restored several times throughout history",
                    "The political heart of the Emirate of Bukhara",
                    "Considered the historic heart of Bukhara",
                    "Today operates as a museum open to visitors"
                ],

                images: [ark1, ark2, ark3,]
            },

            {
                title: "Lyabi-Hauz Complex — Bukhara",

                content: `
Lyabi-Hauz is one of the most famous and picturesque historical squares in the city of Bukhara.

Centered around a large reflecting pool, this architectural ensemble has served as the social and cultural heart of the city for centuries.

Today, Lyabi-Hauz is one of Bukhara's most vibrant attractions, where history, culture, and everyday life come together in a unique atmosphere.
    `,

                details: `
The Lyabi-Hauz Complex was developed during the 16th and 17th centuries and became one of Bukhara's principal social and commercial centers.

📌 The complex includes:
- Nadir Divan-Begi Madrasa
- Nadir Divan-Begi Khanqah
- The historic Lyabi-Hauz pool
- Traditional shops and artisan workshops

📌 History:
For centuries, the pool served as an important source of drinking water and as the city's main gathering place. Merchants, Silk Road caravans, scholars, and local residents regularly met here.

📌 Architecture:
- Beautiful madrasa decorated with blue glazed tiles
- Large central reflecting pool
- Square surrounded by centuries-old plane trees
- Elegant symmetry characteristic of traditional Central Asian architecture

📌 Significance:
Lyabi-Hauz has long been regarded as the social heart of Bukhara, where education, trade, hospitality, and culture flourished together.
    `,

                facts: [
                    "Located in the heart of Bukhara",
                    "Developed during the 16th and 17th centuries",
                    "Features a large historic reflecting pool",
                    "Built under the patronage of Nadir Divan-Begi",
                    "Includes a madrasa and a khanqah",
                    "Served as an important commercial center",
                    "A popular stop for Silk Road caravans",
                    "Famous for its ancient plane trees",
                    "Considered the social center of historic Bukhara",
                    "A fine example of Central Asian Islamic architecture",
                    "One of Bukhara's most visited tourist attractions",
                    "Today it is a popular place for relaxation and sightseeing",
                    "The pool once supplied water to the surrounding community",
                    "Located within the UNESCO World Heritage area",
                    "Beautifully illuminated at night",
                    "Surrounded by traditional restaurants and tea houses",
                    "One of the liveliest districts in Bukhara",
                    "A historic center of culture and commerce",
                    "Among the city's most photographed locations",
                    "A unique blend of history and modern city life"
                ],

                images: [lyabi1, lyabi2, lyabi3,]
            },

            {
                title: "Samanid Mausoleum — Bukhara",

                content: `
The Samanid Mausoleum is one of the oldest and most remarkable architectural monuments in the city of Bukhara.

Built as the royal tomb of the Samanid dynasty, it is widely regarded as one of the earliest and finest masterpieces of Islamic architecture.

Today, the mausoleum is recognized as one of Uzbekistan's oldest surviving monuments and a priceless symbol of the nation's rich historical and cultural heritage.
    `,

                details: `
The Samanid Mausoleum was constructed between the late 9th and early 10th centuries (approximately 892–943 AD) and is closely associated with Ismail Samani, the founder of the Samanid dynasty.

📌 Historical significance:
- Royal mausoleum of the Samanid dynasty
- One of the earliest surviving monuments of Islamic architecture
- Marked the beginning of decorative brick architecture in Central Asia

📌 Architecture:
- Square-shaped structure
- Constructed entirely from baked bricks
- Intricate geometric patterns created solely through brickwork
- Perfectly symmetrical design
- Decorative effects achieved through the interplay of light and shadow

📌 Significance:
The Samanid Mausoleum is celebrated as a masterpiece of Islamic brick architecture and inspired many architectural traditions that flourished throughout the Islamic world in later centuries.
    `,

                facts: [
                    "Located in the city of Bukhara",
                    "Built during the 9th and 10th centuries",
                    "Closely associated with Ismail Samani",
                    "Royal mausoleum of the Samanid dynasty",
                    "One of the oldest surviving monuments of Islamic architecture",
                    "Constructed entirely from baked bricks",
                    "Features a square architectural plan",
                    "Renowned for its perfect symmetry",
                    "Decorated with intricate geometric brick patterns",
                    "One of the world's oldest preserved Islamic monuments",
                    "Situated in the historic center of Bukhara",
                    "Part of the UNESCO World Heritage Site",
                    "A masterpiece of brick architecture",
                    "Its design creates unique light and shadow effects",
                    "Influenced the development of later Islamic architecture",
                    "Considered a milestone in the history of Eastern architecture",
                    "A popular destination for pilgrims and tourists",
                    "Holds exceptional historical and spiritual significance",
                    "Recognized as a masterpiece of world architecture",
                    "One of the oldest surviving monuments in Bukhara"
                ],

                images: [somoniy1, somoniy2, somoniy3,]
            },

            {
                title: "Chor Minor — Bukhara",

                content: `
Chor Minor is one of the most unique and recognizable architectural landmarks in the city of Bukhara.

Distinguished by its four elegant minarets, this remarkable gateway immediately captures visitors' attention with its distinctive design and harmonious proportions.

Today, Chor Minor is one of Bukhara's most photogenic attractions and a favorite destination for travelers from around the world.
    `,

                details: `
Chor Minor was built in the early 19th century, around 1807, by the wealthy merchant Khalifa Niyazkul.

📌 Meaning of the name:
The name "Chor Minor" comes from Persian and literally means "Four Minarets."

📌 Structure:
- Four elegant minarets
- Central domed chamber
- Monumental entrance portal
- Inner courtyard

📌 Architecture:
- Decorated with beautiful blue and green glazed tiles
- Each minaret features its own unique decorative style
- Harmonious symmetry with an unusual architectural design
- A blend of Indian and Central Asian architectural influences

📌 Historical significance:
Originally, Chor Minor served as the entrance to a madrasa complex. Although the main madrasa building has disappeared over time, the gateway remains one of Bukhara's most iconic historical monuments.
    `,

                facts: [
                    "Located in the city of Bukhara",
                    "Built around 1807",
                    "Commissioned by Khalifa Niyazkul",
                    "\"Chor Minor\" means \"Four Minarets\" in Persian",
                    "Originally served as the entrance to a madrasa",
                    "Famous for its four distinctive minarets",
                    "Decorated with blue glazed tiles",
                    "Features a unique symmetrical design",
                    "Blends Indian and Central Asian architectural styles",
                    "One of Bukhara's most photogenic landmarks",
                    "A small but world-famous monument",
                    "Located near the UNESCO World Heritage area",
                    "One of the city's most popular tourist attractions",
                    "The original madrasa building no longer survives",
                    "Built as a monumental entrance gateway",
                    "A rare example of Islamic architecture",
                    "One of Bukhara's most distinctive historic buildings",
                    "Among the most photographed landmarks in the city",
                    "Especially beautiful when illuminated at night",
                    "One of the iconic symbols of Bukhara"
                ],

                images: [chor1, chor2, chor3,]
            },
        ]
    },



    fr: {
        key: "bukhara",
        title: "Boukhara — Le cœur millénaire du savoir et de la spiritualité",

        intro: `
Boukhara est l'une des plus anciennes et des plus sacrées villes d'Ouzbékistan, avec plus de 2 500 ans d'histoire.

Autrefois, elle était l'un des plus importants centres commerciaux, scientifiques et culturels de la Grande Route de la Soie.
    `,

        history: `
Boukhara est l'une des plus anciennes villes d'Asie centrale, avec une histoire qui s'étend sur plus de 2 500 ans. Pendant des siècles, elle a été un grand centre religieux, scientifique, culturel et commercial.

Dans l'Antiquité, Boukhara constituait l'une des principales étapes de la Grande Route de la Soie, reliant l'Orient et l'Occident. Des marchands, des savants et des voyageurs venus de Chine, de Perse, d'Inde, du monde arabe et d'Europe s'y rencontraient.

Aux IXe et Xe siècles, sous la dynastie des Samanides, Boukhara devint l'un des plus grands centres de la civilisation islamique. De grands érudits tels que l'Imam Al-Boukhari et Avicenne (Ibn Sina) y étudièrent et y développèrent leurs connaissances.

La ville reçut le surnom de « Qubbat al-Islam » (« Le Dôme de l'Islam »), en raison de ses centaines de médersas, de mosquées et de centres d'enseignement.

Par la suite, Boukhara continua de prospérer sous les Karakhanides, les Khorezmshahs, les Timourides et l'Émirat de Boukhara, chaque époque enrichissant son patrimoine architectural et culturel.

Aujourd'hui, des milliers de monuments historiques sont encore remarquablement préservés, faisant de Boukhara l'une des plus belles villes historiques du monde islamique et un site inscrit au patrimoine mondial de l'UNESCO.
`,

        sections: [
            {
                title: "Ensemble Po-i-Kalyan — Boukhara",

                content: `
L'ensemble Po-i-Kalyan est l'un des monuments historiques et religieux les plus emblématiques de la ville de Boukhara.

Également connu sous le nom de « Grand Ensemble du Minaret », il est considéré comme l'un des plus beaux chefs-d'œuvre de l'architecture islamique en Asie centrale.

Depuis des siècles, ce complexe constitue le cœur spirituel, éducatif et historique de Boukhara.
    `,

                details: `
L'ensemble Po-i-Kalyan a commencé à prendre forme au XIIe siècle et s'est progressivement agrandi au fil des siècles.

📌 Le complexe comprend :
- Le minaret Kalyan (1127)
- La mosquée Kalyan
- La médersa Mir-i-Arab

📌 Histoire :
Le minaret Kalyan fut construit en 1127 sur ordre du souverain karakhanide Arslan Khan. En plus de son rôle religieux, il servait de repère aux caravanes qui parcouraient la Grande Route de la Soie.

📌 Architecture :
- Construit en briques cuites
- Décoré de magnifiques carreaux émaillés bleus et blancs
- Ornements géométriques caractéristiques de l'art islamique
- Portails monumentaux et composition parfaitement symétrique

📌 Importance :
L'ensemble Po-i-Kalyan est considéré comme le symbole spirituel de Boukhara et demeure depuis des siècles un important centre de savoir, d'enseignement islamique et de vie religieuse.
    `,

                facts: [
                    "Situé dans la ville de Boukhara",
                    "Construit à partir du XIIe siècle",
                    "Le minaret Kalyan a été édifié en 1127",
                    "Construit sous le règne d'Arslan Khan",
                    "Le complexe comprend trois monuments principaux",
                    "La médersa Mir-i-Arab est l'une des plus prestigieuses d'Asie centrale",
                    "La mosquée Kalyan est l'une des plus grandes mosquées de la région",
                    "Chef-d'œuvre de l'architecture islamique",
                    "Ancien centre majeur de la Grande Route de la Soie",
                    "Le minaret servait de repère aux caravanes",
                    "Construit en briques cuites",
                    "Décoré de magnifiques carreaux émaillés bleus",
                    "Le cœur religieux de Boukhara",
                    "Inscrit au patrimoine mondial de l'UNESCO",
                    "L'un des plus beaux exemples de l'architecture orientale",
                    "L'un des sites touristiques les plus visités de Boukhara",
                    "Remarquablement conservé depuis plus de huit siècles",
                    "Présente une architecture harmonieuse et symétrique",
                    "L'un des principaux symboles de Boukhara",
                    "Particulièrement spectaculaire lorsqu'il est illuminé la nuit"
                ],

                images: [poi1, poi2, poi3,]
            },

            {
                title: "Forteresse de l'Ark — Boukhara",

                content: `
La forteresse de l'Ark est la plus ancienne et la plus importante citadelle historique de la ville de Boukhara.

Pendant des siècles, elle a servi de résidence officielle aux émirs de Boukhara et constituait le centre politique, militaire et administratif de la ville.

Aujourd'hui, la forteresse de l'Ark est l'un des monuments historiques les plus célèbres de Boukhara et une étape incontournable pour les visiteurs souhaitant découvrir le riche patrimoine de l'Ouzbékistan.
    `,

                details: `
La forteresse de l'Ark est l'un des plus anciens édifices de Boukhara, dont les origines remontent à l'Antiquité. Son apparence actuelle s'est principalement développée entre les XVIe et XIXe siècles.

📌 Importance historique :
- Résidence officielle des émirs de Boukhara
- Centre du gouvernement et de l'administration
- Lieu où étaient prises les principales décisions politiques et militaires

📌 Le complexe comprend :
- D'imposants remparts fortifiés
- Le palais de l'émir
- Des salles de réception
- Une mosquée
- Une prison (Zindan)
- Un atelier de frappe de monnaie
- Des quartiers militaires

📌 Architecture :
- Épais remparts en briques de terre crue
- Système de défense particulièrement solide
- Grandes cours intérieures
- Architecture traditionnelle d'Asie centrale et du monde islamique

📌 Fait intéressant :
Construite sur une colline artificielle, la forteresse de l'Ark occupait le point le mieux défendu de Boukhara et offrait un avantage stratégique contre les invasions.
    `,

                facts: [
                    "Située dans la ville de Boukhara",
                    "L'une des plus anciennes forteresses d'Asie centrale",
                    "Son histoire remonte à plus de deux mille ans",
                    "Résidence des émirs entre les XVIe et XIXe siècles",
                    "Centre administratif de l'Émirat de Boukhara",
                    "Important centre politique et militaire",
                    "Abrite la célèbre prison du Zindan",
                    "Possédait un atelier de frappe de monnaie",
                    "Construite sur une colline pour renforcer sa défense",
                    "Protégée par d'imposants remparts fortifiés",
                    "Principalement construite en briques de terre",
                    "La plus grande forteresse historique de Boukhara",
                    "L'un des sites touristiques les plus visités",
                    "Abrite un vaste complexe palatial",
                    "Bel exemple de l'architecture islamique d'Asie centrale",
                    "Inscrite au patrimoine mondial de l'UNESCO",
                    "Restaurée à plusieurs reprises au cours de son histoire",
                    "Ancien cœur politique de l'Émirat de Boukhara",
                    "Considérée comme le cœur historique de Boukhara",
                    "Aujourd'hui ouverte au public en tant que musée"
                ],

                images: [ark1, ark2, ark3,]
            },
            {
                title: "Ensemble Lyabi-Hauz — Boukhara",

                content: `
L'ensemble Lyabi-Hauz est l'une des places historiques les plus célèbres et les plus pittoresques de la ville de Boukhara.

Organisé autour d'un grand bassin historique, ce magnifique ensemble architectural constitue depuis des siècles le cœur social, culturel et commercial de la ville.

Aujourd'hui, Lyabi-Hauz est l'un des lieux les plus animés de Boukhara, où histoire, culture et vie quotidienne se rencontrent dans une atmosphère unique.
    `,

                details: `
L'ensemble Lyabi-Hauz a été aménagé entre les XVIe et XVIIe siècles et est rapidement devenu l'un des principaux centres sociaux et commerciaux de Boukhara.

📌 Le complexe comprend :
- La médersa Nadir Divan-Begi
- Le khanqah de Nadir Divan-Begi
- Le bassin historique (Hauz)
- De nombreuses boutiques d'artisans et de commerçants

📌 Histoire :
Pendant des siècles, le bassin a constitué une importante réserve d'eau potable et le principal lieu de rassemblement des habitants. Les caravanes de la Route de la Soie, les marchands, les savants et les voyageurs s'y retrouvaient régulièrement.

📌 Architecture :
- Magnifique médersa décorée de carreaux émaillés bleus
- Grand bassin central reflétant les monuments
- Place entourée de majestueux platanes centenaires
- Architecture orientale élégante et parfaitement symétrique

📌 Importance :
Lyabi-Hauz est considéré comme le cœur vivant de Boukhara, où le commerce, le savoir, l'hospitalité et la culture se sont développés ensemble pendant des siècles.
    `,

                facts: [
                    "Situé au cœur de la ville de Boukhara",
                    "Aménagé entre les XVIe et XVIIe siècles",
                    "Possède un grand bassin historique",
                    "Construit sous le patronage de Nadir Divan-Begi",
                    "Comprend une médersa et un khanqah",
                    "Ancien centre commercial majeur",
                    "Lieu d'arrêt des caravanes de la Route de la Soie",
                    "Célèbre pour ses platanes centenaires",
                    "Considéré comme le centre social de Boukhara historique",
                    "Magnifique exemple de l'architecture islamique d'Asie centrale",
                    "L'un des sites les plus visités de Boukhara",
                    "Aujourd'hui un lieu apprécié pour la promenade et la détente",
                    "Le bassin servait autrefois de réserve d'eau potable",
                    "Situé dans la zone classée au patrimoine mondial de l'UNESCO",
                    "Magnifiquement illuminé à la tombée de la nuit",
                    "Entouré de restaurants traditionnels et de maisons de thé",
                    "L'un des quartiers les plus animés de Boukhara",
                    "Ancien centre de commerce et de culture",
                    "Parmi les lieux les plus photographiés de la ville",
                    "Un parfait mélange entre patrimoine historique et vie moderne"
                ],

                images: [lyabi1, lyabi2, lyabi3,]
            },
            {
                title: "Le Mausolée des Samanides — Boukhara",

                content: `
Le Mausolée des Samanides est l’un des monuments architecturaux les plus anciens et les plus prestigieux de Boukhara.

Construit pour la dynastie des Samanides, il est considéré comme l’un des premiers et des plus remarquables chefs-d'œuvre de l’architecture islamique.

Aujourd’hui, il demeure l’un des monuments les mieux conservés et les plus précieux du patrimoine historique de l’Ouzbékistan.
    `,

                details: `
Le Mausolée des Samanides a été construit entre les IXe et Xe siècles (environ de 892 à 943) et est étroitement associé à Ismaïl Samani, l’un des souverains les plus célèbres de la dynastie samanide.

📌 Importance historique :
- Mausolée de la dynastie des Samanides
- L’un des plus anciens monuments de l’architecture islamique
- Marque le début de l’art décoratif en briques en Asie centrale

📌 Architecture :
- Plan carré parfaitement équilibré
- Construit entièrement en briques cuites
- Motifs géométriques réalisés uniquement avec les briques
- Composition parfaitement symétrique
- Décoration jouant sur les effets de lumière et d’ombre

📌 Importance :
Le Mausolée des Samanides est reconnu comme un chef-d’œuvre de l’architecture en briques dans le monde islamique et a profondément influencé le développement de l’architecture des siècles suivants.
    `,

                facts: [
                    "Situé dans la ville de Boukhara",
                    "Construit entre les IXe et Xe siècles",
                    "Étroitement lié à Ismaïl Samani",
                    "Mausolée de la dynastie des Samanides",
                    "L’un des plus anciens monuments de l’architecture islamique",
                    "Construit en briques cuites",
                    "Édifice de forme carrée",
                    "Conçu selon un plan parfaitement symétrique",
                    "Orné de motifs géométriques en briques",
                    "L’un des plus anciens monuments islamiques conservés au monde",
                    "Situé dans le centre historique de Boukhara",
                    "Inscrit au patrimoine mondial de l’UNESCO",
                    "Chef-d’œuvre de l’art de la brique",
                    "Décoration basée sur les jeux de lumière et d’ombre",
                    "A profondément influencé l’architecture des époques suivantes",
                    "Considéré comme l’un des premiers chefs-d’œuvre de l’architecture orientale",
                    "Lieu de pèlerinage historique",
                    "Possède une grande importance historique et religieuse",
                    "Reconnu comme un joyau de l’architecture mondiale",
                    "L’un des monuments les plus anciens de Boukhara"
                ],

                images: [somoniy1, somoniy2, somoniy3],
            },

            {
                title: "Tchor Minor — Boukhara",

                content: `
Tchor Minor est l’un des monuments architecturaux les plus uniques et emblématiques de Boukhara.

Reconnaissable à ses quatre élégants minarets, ce portail historique se distingue par son architecture exceptionnelle et son charme incomparable.

Aujourd’hui, Tchor Minor est l’un des sites les plus photographiés de Boukhara et une étape incontournable pour les visiteurs du monde entier.
    `,

                details: `
Tchor Minor a été construit vers 1807 par le riche marchand Khalifa Niyazkoul.

📌 Signification :
Le nom « Tchor Minor » vient du persan et signifie « Quatre Minarets ».

📌 Structure :
- Quatre minarets distinctifs
- Une salle centrale coiffée d'un dôme
- Un portail monumental
- Une cour intérieure

📌 Architecture :
- Décorations en céramiques bleues et vertes
- Chaque minaret possède des ornements uniques
- Composition parfaitement symétrique
- Fusion des styles architecturaux d’Asie centrale et de l’Inde

📌 Importance historique :
À l’origine, Tchor Minor constituait le portail d’entrée d’une médersa. Bien que le reste du complexe ait disparu au fil du temps, ce magnifique portail est resté intact et demeure l’un des symboles les plus célèbres de Boukhara.
    `,

                facts: [
                    "Situé dans la ville de Boukhara",
                    "Construit vers 1807",
                    "Édifié par Khalifa Niyazkoul",
                    "« Tchor Minor » signifie « Quatre Minarets »",
                    "Servait autrefois de portail d’entrée d’une médersa",
                    "Célèbre pour ses quatre minarets distinctifs",
                    "Décoré de magnifiques céramiques bleues",
                    "Présente une architecture parfaitement symétrique",
                    "Combine les styles architecturaux indien et d’Asie centrale",
                    "L’un des monuments les plus photogéniques de Boukhara",
                    "Petit par sa taille mais mondialement connu",
                    "Situé à proximité de la zone classée au patrimoine mondial de l’UNESCO",
                    "Une attraction touristique incontournable",
                    "Le reste de la médersa a disparu avec le temps",
                    "Construit comme portail monumental",
                    "Un exemple exceptionnel de l’architecture islamique orientale",
                    "L’un des édifices les plus originaux de Boukhara",
                    "Très apprécié des photographes et des voyageurs",
                    "Magnifiquement illuminé à la tombée de la nuit",
                    "L’un des symboles historiques les plus emblématiques de Boukhara"
                ],

                images: [chor1, chor2, chor3],
            },



        ]

    }
};

export default bukhara;